module.exports = __webpack_public_path__ + "img/Group 427320697@2x.73306a8d.png";